import { render, staticRenderFns } from "./BilledDetail.vue?vue&type=template&id=6efe77bc&scoped=true&"
import script from "./BilledDetail.vue?vue&type=script&lang=js&"
export * from "./BilledDetail.vue?vue&type=script&lang=js&"
import style0 from "./BilledDetail.vue?vue&type=style&index=0&id=6efe77bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe77bc",
  null
  
)

export default component.exports